import styles from "./CanvasSidebar.module.css";

export type SidebarTool = "add-workflow" | "add-pipeline" | "add-form" | null;

interface Props {
  active: SidebarTool;
  onToggle: (tool: SidebarTool) => void;
}

export default function CanvasSidebar({ active, onToggle }: Props) {
  return (
    <aside className={styles.sidebar}>
      <button
        type="button"
        className={`${styles.button} ${active === "add-workflow" ? styles.buttonActive : ""}`}
        onClick={() =>
          onToggle(active === "add-workflow" ? null : "add-workflow")
        }
        title="Add workflow"
        aria-label="Add workflow"
        aria-pressed={active === "add-workflow"}
      >
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path
            d="M10 4v12M4 10h12"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </svg>
      </button>
      <button
        type="button"
        className={`${styles.button} ${active === "add-pipeline" ? styles.buttonActive : ""}`}
        onClick={() =>
          onToggle(active === "add-pipeline" ? null : "add-pipeline")
        }
        title="Add pipeline"
        aria-label="Add pipeline"
        aria-pressed={active === "add-pipeline"}
      >
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
          <rect
            x="3"
            y="5"
            width="3"
            height="10"
            rx="1"
            stroke="currentColor"
            strokeWidth="1.6"
          />
          <rect
            x="8.5"
            y="5"
            width="3"
            height="10"
            rx="1"
            stroke="currentColor"
            strokeWidth="1.6"
          />
          <rect
            x="14"
            y="5"
            width="3"
            height="10"
            rx="1"
            stroke="currentColor"
            strokeWidth="1.6"
          />
        </svg>
      </button>
      <button
        type="button"
        className={`${styles.button} ${active === "add-form" ? styles.buttonActive : ""}`}
        onClick={() => onToggle(active === "add-form" ? null : "add-form")}
        title="Add form"
        aria-label="Add form"
        aria-pressed={active === "add-form"}
      >
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
          <rect
            x="3.5"
            y="3.5"
            width="13"
            height="13"
            rx="2"
            stroke="currentColor"
            strokeWidth="1.6"
          />
          <path
            d="M6 7h8M6 10h8M6 13h5"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinecap="round"
          />
        </svg>
      </button>
    </aside>
  );
}
